import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cl-frame"
  }, [_vm.orientation === 'square' ? _c(VImg, {
    attrs: {
      "height": "110",
      "max-height": "110",
      "max-width": "110",
      "contain": "",
      "src": _vm.image
    }
  }) : _c(VImg, {
    attrs: {
      "max-height": "110",
      "min-height": "110",
      "max-width": "200",
      "src": _vm.image,
      "contain": ""
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };